import { css, jsx } from '@emotion/react';
import { Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../universal-nav/hooks';
import { boxSizing, listReset } from '../../../utils/style-mixins/reset';
export const CssVars = {
    flexDirection: '--UniversalFooter__HelpfulLinks-flex-direction',
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const Styles = {
    root: css `
    ${listReset};
    display: flex;
    flex-direction: var(${CssVars.flexDirection}, column);
    justify-content: var(${CssVars.justifyContent}, center);
    text-align: center;
    flex-wrap: wrap;
    column-gap: 12.5px;
    row-gap: 10px;
  `,
    link: css `
    ${boxSizing};
    font: var(--zds-body-3);
    color: var(--zds-gray-warm-9, #413735) !important;
    // For browsers that don't yet support Flexbox gap
    padding: 0 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: var(--zds-ui-primary-strongest, #503ebd) !important;
      outline: none;
    }
  `,
};
export const HelpfulLinks = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { links = [
        { text: 'Pricing', href: '/pricing' },
        { text: 'Help', href: 'https://help.zapier.com/hc/en-us' },
        { text: 'Developer Platform', href: '/platform' },
        { text: 'Press', href: '/press' },
        { text: 'Jobs', href: '/jobs' },
        {
            text: 'Zapier for Companies',
            href: '/teams-companies',
        },
        { text: 'Templates', href: '/templates' },
    ], } = props;
    const linkNodes = links.map((link) => {
        return (jsx("li", { key: link.text, "data-zds": true },
            jsx(Link, { color: null, css: Styles.link, href: getFullyQualifiedURL(link.href) }, link.text)));
    });
    return (jsx("ul", { css: Styles.root, "data-zds": true }, linkNodes));
};
//# sourceMappingURL=HelpfulLinks.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
